export default {
  pageTitle: '管理我的店铺',
  applyStore: '申请创建新店铺',
  payMethod: '保证金缴纳方式',
  bank: '银行',
  bankAccount: '银行账号',
  payee: '收款方',
  paymentTerm: '协议',
  marginStatusList1: '挂起',
  marginStatusList2: '已缴纳',
  statusType1: '营业中',
  statusType2: '打烊',
  statusType3: '关店',
  storeType1: '个人',
  storeType2: '企业',
  columns1: '店铺类型',
  columns2: '店铺等级',
  columns3: '店铺名',
  columns4: '店铺Logo',
  storeInfo: '店铺信息',
  columns5: '创建时间',
  columns6: '佣金率',
  columns7: '状态',
  columns8: '保证金缴纳状态',
  columns9: '查看',
  storeId: '店铺编号',
  approvedStores: '已审核通过的店铺',
  pendingReviewStores: '正在审核中店铺',
  rejectedStores: '已拒绝店铺',
  operation: '操作',
  edit: '编辑',
  latestRejectionReason: '最近拒绝原因',
  applicationTime: '提交申请日期',
  view: '查看',
  basicMarketplace: '市场基站',
  createDate: '开店日期',
  open: '营业中',
  temporarilyClosed: '歇业中',
  locked: '已冻结',
  permanentlyClosed: '已关店',
  viewCommissionRates: '查看佣金率',
  viewKilimallSellerEContract: '查看Kilimall平台在线合约',
  viewLipaPayTermConditions: '查看LipaPay条款',
  viewQualification: '查看店铺资质',
  storeQualification: '店铺资质信息',
  revisionApplicationRecord: '修订申请历史',
  applicationId: '申请编号',
  scope: '修订范畴',
  type: '修订类型',
  applyDate: '申请日期',
  auditDate: '审核日期',
  cancel: '取消',
  details: '详情',
  inReview: '审核中',
  approved: '已批准',
  rejected: '已拒绝',
  canceled: '已取消',
  pleaseSelectReviseType: '请选择修订类型',
  areYouSureCancelApplication: '您是否确认取消这次修订申请？',
  yesCancelIt: '是的，取消申请',
  noKeepIt: '不取消',
  submitRevisionApplication: '提交修订申请',
  submitRevisionApplicationTip: '由于平台政策调整，修改店铺营业信息或结算资料将一并应用到商户下所有店铺，提交表示已知悉并同意此政策',
  revise: '修订',
  cancelRevision: '取消修订',
  changeToANewOne: '替换为新资质信息',
  correctTheWrongInfo: '订正当前错误的信息',
  doYouAgreeQualifications: '您帐号下的这些店铺的资质和当前店铺的原资质相同，是否同意进行同步订正？',
  noDisagree: '不同意',
  yesAgree: '同意',
  status: '申请状态',
  storeStatus: '店铺状态',
  theOriginalCannotIndividually: '原资质有多个店铺，不能进行单一订正',
  indicatesStatusBasic: '这是店铺在基站市场的状态。',
  failedBecauseHaveNotRevised: '您并未修订任何信息',
  failedBecauseLockedOrClosed: '已经冻结或关店的店铺不能申请。',
  correction: '订正',
  change: '变更',
  qualifications: '资质与结算信息',
  settlement: '结算信息',
  representative: '法人信息',
  missingInfoSupplement: '补充结算信息',
  supplement: '补充',
  closeStore: '关闭店铺',
  applyCloseRegion: '申请关闭国家站',
  confirm: '确认',
  requestingCloseBaseStation: '您申请关闭的是店铺基站,请选择新的基站:',
  previous: '返回',
  baseStation: '基站',
  pleaseSelect: '请选择',
  closureApplicationStores: '关闭店铺申请店铺',
  applicationDate: '申请日期',
  storeRegion: '店铺区域',
  feedbackDate: '反馈日期',
  refundSuccess: '退款成功'
}
